export const contactsLinks = {
	messenger: 'https://www.m.me/www.winwin.travel/',
	instagram: 'https://www.instagram.com/winwin_travel/',
	whatsapp: 'https://wa.me/+380666161868/',
	facebook: 'https://www.facebook.com/www.winwin.travel/',
	tiktok: 'https://www.tiktok.com/@winwin.travel/'
}
